import React from 'react';
import Drawer, {type DrawerProps} from './Drawer';

export interface WithDrawerProps {
	DrawerProps: DrawerProps;
}

export function withDrawer<C extends React.ElementType>(Component: C) {
	return ({
		DrawerProps,
		...props
	}: WithDrawerProps &
		JSX.IntrinsicAttributes &
		JSX.LibraryManagedAttributes<C, React.ComponentProps<C>>) => {
		return (
			<Drawer {...DrawerProps}>
				<Component
					{...(props as JSX.IntrinsicAttributes &
						JSX.LibraryManagedAttributes<C, React.ComponentProps<C>>)}
				/>
			</Drawer>
		);
	};
}

export default withDrawer;
